import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router} from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const normalizeLocalStorageStringValue = (key) => {
  const value = localStorage.getItem(key);
  if (value === null) return;

  try {
    JSON.parse(value);
  } catch (error) {
    // Migrate legacy plain-string values (like raw JWT) to JSON string format
    localStorage.setItem(key, JSON.stringify(value));
  }
};

normalizeLocalStorageStringValue('token');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
    <App />
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
